/* Theme JavaScript synced for Shopify Theme Assets & Hero Slider Engine */
let currentHeroSlideIndex = 0;
let heroSlideTimer = null;

const PRODUCTS = [
  {
    id: 'lady-boss',
    name: 'Lady Boss',
    subtitle: 'Eau De Parfum Flagship',
    category: 'women',
    family: 'Floral Oriental',
    price: 380,
    sizes: [
      { size: '50 ml / 1.7 oz', price: 240 },
      { size: '100 ml / 3.4 oz', price: 380, popular: true },
      { size: '200 ml Refill', price: 580 }
    ],
    rating: 5.0,
    reviewsCount: 142,
    badge: 'Flagship Signature',
    image: 'assets/products/product-01.webp',
    gallery: ['assets/products/product-01.webp', 'assets/banners/hero-banner.webp', 'assets/ingredients/rose.webp'],
    notes: {
      top: ['Damascena Rose', 'Pink Pepper', 'Italian Bergamot'],
      heart: ['Iris Absolute', 'Jasmin de Grasse', 'Orange Blossom'],
      base: ['Bourbon Vanilla', 'Velvet Cedar', 'White Musk', 'Liquid Amber']
    },
    specs: { concentration: '22% Extrait de Parfum', longevity: '8 - 12 Hours', projection: '6+ Feet Sillage', origin: 'Grasse & Paris, France' },
    description: 'Empowering, radiant, and undeniably sophisticated. Lady Boss opens with vibrant pink pepper and hand-picked Damascena Rose from Grasse, unfolding into a hypnotic heart of French Iris and rich Bourbon Vanilla.'
  },
  {
    id: 'velvet-nectar',
    name: 'Velvet Nectar',
    subtitle: 'Eau De Parfum',
    category: 'women',
    family: 'Floral Gourmand',
    price: 340,
    sizes: [{ size: '50 ml / 1.7 oz', price: 210 }, { size: '100 ml / 3.4 oz', price: 340 }],
    rating: 4.9,
    reviewsCount: 98,
    badge: 'Best Seller',
    image: 'assets/products/product-02.webp',
    gallery: ['assets/products/product-02.webp', 'assets/ingredients/rose.webp'],
    notes: { top: ['Wild Raspberry', 'Pink Pepper'], heart: ['Damascena Rose', 'Orchid'], base: ['Honeyed Amber', 'Sandalwood'] },
    specs: { concentration: '20% Eau De Parfum', longevity: '8+ Hours', projection: '5 Feet Sillage', origin: 'Grasse, France' },
    description: 'A seductive symphony of wild raspberry and velvety rose dipped in golden honeyed amber.'
  },
  {
    id: 'noir-absolute',
    name: 'Noir Absolute',
    subtitle: 'Extrait de Parfum',
    category: 'men',
    family: 'Smoky Woody',
    price: 420,
    sizes: [{ size: '50 ml / 1.7 oz', price: 270 }, { size: '100 ml / 3.4 oz', price: 420, popular: true }],
    rating: 4.95,
    reviewsCount: 116,
    badge: 'Niche Reserve',
    image: 'assets/products/product-03.webp',
    gallery: ['assets/products/product-03.webp', 'assets/ingredients/vanilla.webp'],
    notes: { top: ['Smoked Cardamom', 'Black Pepper'], heart: ['Birch Tar', 'Atlas Cedar'], base: ['Dark Amber', 'Bourbon Vanilla'] },
    specs: { concentration: '25% Extrait de Parfum', longevity: '12+ Hours', projection: '8 Feet Sillage', origin: 'Paris, France' },
    description: 'Enigmatic and nocturnal. Smoked cardamom meets rich atlas cedar and dark bourbon vanilla.'
  },
  {
    id: 'scent-of-eden',
    name: 'Scent of Eden',
    subtitle: 'Eau De Parfum',
    category: 'unisex',
    family: 'Fresh Botanical',
    price: 320,
    sizes: [{ size: '50 ml / 1.7 oz', price: 195 }, { size: '100 ml / 3.4 oz', price: 320 }],
    rating: 4.85,
    reviewsCount: 74,
    badge: 'New Arrival',
    image: 'assets/products/product-04.webp',
    gallery: ['assets/products/product-04.webp', 'assets/ingredients/cedar.webp'],
    notes: { top: ['Calabrian Bergamot', 'Green Fig'], heart: ['White Iris', 'Neroli'], base: ['Clean Musk', 'Driftwood'] },
    specs: { concentration: '18% Eau De Parfum', longevity: '7 - 9 Hours', projection: '4 Feet Sillage', origin: 'Grasse, France' },
    description: 'An ethereal paradise of sun-kissed bergamot, fresh green fig leaves, and powdery white iris.'
  }
];

const FRAGRANCE_NOTES = {
  top: {
    title: 'Top Notes — The First Impression',
    phase: 'Initial 15 Minutes',
    desc: 'The vibrant opening burst of Lady Boss. Fresh, sparkling Damascena Rose paired with invigorating Pink Pepper and Calabrian Bergamot.',
    ingredients: [
      { name: 'Damascena Rose', origin: 'Grasse, France', img: 'assets/ingredients/rose.webp' },
      { name: 'Pink Pepper', origin: 'Reunion Island', img: 'assets/ingredients/pepper.webp' }
    ]
  },
  heart: {
    title: 'Heart Notes — The Scent Soul',
    phase: 'Hours 1 to 4',
    desc: 'The captivating heart that defines the signature aura. Powdery French Iris Absolute combined with Jasmine de Grasse.',
    ingredients: [
      { name: 'Iris Absolute', origin: 'Florence, Italy', img: 'assets/ingredients/rose.webp' },
      { name: 'Jasmin de Grasse', origin: 'Grasse, France', img: 'assets/ingredients/rose.webp' }
    ]
  },
  base: {
    title: 'Base Notes — The Lasting Sillage',
    phase: 'Hours 4 to 12+',
    desc: 'Deep, sensual dry-down anchored by hand-picked Madagascar Bourbon Vanilla and smooth Atlas Velvet Cedarwood.',
    ingredients: [
      { name: 'Bourbon Vanilla', origin: 'Madagascar', img: 'assets/ingredients/vanilla.webp' },
      { name: 'Velvet Cedar', origin: 'Atlas Mountains', img: 'assets/ingredients/cedar.webp' }
    ]
  }
};

let cart = [];
let wishlist = new Set(['lady-boss']);
let currentActivePdpProduct = PRODUCTS[0];
let selectedPdpSize = PRODUCTS[0].sizes[1];
let customEngravingText = '';

document.addEventListener('DOMContentLoaded', () => {
  initNavbarScroll();
  initHeroSlider();
  initTimerCountdown();
  renderProductsGrid('all');
  initNotesTabs();
  initCartEvents();
  initScrollAnimations();
});

// --- Hero Slider Engine (Screenshots 1 & 2) ---
function initHeroSlider() {
  const slides = document.querySelectorAll('.hero-slide-item');
  slides.forEach(slide => {
    slide.style.cursor = 'pointer';
    slide.addEventListener('click', (e) => {
      if (e.target.closest('.hero-slider-pagination') || e.target.closest('a')) return;
      const targetUrl = slide.getAttribute('data-href') || '/collections/all';
      window.location.href = targetUrl;
    });
  });

  if (slides.length <= 1) return;

  heroSlideTimer = setInterval(() => {
    let nextIndex = (currentHeroSlideIndex + 1) % slides.length;
    goToHeroSlide(nextIndex);
  }, 5000);
}

function goToHeroSlide(index) {
  const slides = document.querySelectorAll('.hero-slide-item');
  const paginationLines = document.querySelectorAll('.hero-page-line');

  if (slides.length === 0) return;

  slides.forEach((slide, i) => {
    slide.classList.toggle('active', i === index);
  });

  paginationLines.forEach((line, i) => {
    line.classList.toggle('active', i === index);
  });

  currentHeroSlideIndex = index;
}

// --- Top Timer Countdown Engine (Screenshot 1) ---
function initTimerCountdown() {
  let seconds = 16 * 86400 + 11 * 3600 + 49 * 60 + 43;
  setInterval(() => {
    if (seconds <= 0) return;
    seconds--;
    const d = Math.floor(seconds / 86400);
    const h = Math.floor((seconds % 86400) / 3600);
    const m = Math.floor((seconds % 3600) / 60);
    const s = Math.floor(seconds % 60);

    const dEl = document.getElementById('timerDays');
    const hEl = document.getElementById('timerHours');
    const mEl = document.getElementById('timerMins');
    const sEl = document.getElementById('timerSecs');

    if (dEl) dEl.innerText = d < 10 ? '0' + d : d;
    if (hEl) hEl.innerText = h < 10 ? '0' + h : h;
    if (mEl) mEl.innerText = m < 10 ? '0' + m : m;
    if (sEl) sEl.innerText = s < 10 ? '0' + s : s;
  }, 1000);
}

function initNavbarScroll() {
  const navbar = document.getElementById('siteNavbar') || document.querySelector('.navbar');
  if (!navbar) return;

  window.addEventListener('scroll', () => {
    if (window.scrollY > 40) {
      navbar.classList.add('scrolled');
    } else {
      navbar.classList.remove('scrolled');
    }
  }, { passive: true });
}



function openSearchModal() {
  const modal = document.getElementById('searchModal');
  if (modal) modal.classList.add('open');
}

function closeSearchModal() {
  const modal = document.getElementById('searchModal');
  if (modal) modal.classList.remove('open');
}

function handlePredictiveSearch(query) {
  const container = document.getElementById('searchResultsContainer');
  if (!container) return;
  const q = query.toLowerCase().trim();
  if (!q) {
    container.innerHTML = `<div style="text-align:center; color:var(--text-muted); padding:2rem 0;"><p style="font-size:0.85rem;">Popular Searches: <em>Lady Boss, Bourbon Vanilla, Velvet Nectar</em></p></div>`;
    return;
  }
  const matches = PRODUCTS.filter(p => p.name.toLowerCase().includes(q) || p.family.toLowerCase().includes(q));
  if (matches.length === 0) {
    container.innerHTML = `<p style="text-align:center; color:var(--text-muted); padding:1rem;">No matching fragrances found.</p>`;
    return;
  }
  container.innerHTML = matches.map(p => `
    <div class="cart-item" style="cursor:pointer;" onclick="closeSearchModal(); openPdpModal('${p.id}');">
      <img src="${p.image}" class="cart-item-img" style="width:60px; height:60px;" alt="${p.name}" />
      <div class="cart-item-info">
        <h5 class="cart-item-title">${p.name}</h5>
        <p class="cart-item-variant">${p.family} • $${p.price}</p>
      </div>
    </div>
  `).join('');
}

function renderProductsGrid(categoryFilter) {
  const container = document.getElementById('productsContainer');
  if (!container) return;
  const filtered = categoryFilter === 'all' ? PRODUCTS : PRODUCTS.filter(p => p.category === categoryFilter);
  container.innerHTML = filtered.map(p => `
    <div class="product-card" data-id="${p.id}">
      <span class="product-badge">${p.badge}</span>
      <button class="product-wishlist-btn ${wishlist.has(p.id) ? 'active' : ''}" onclick="toggleWishlist('${p.id}', event)">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="${wishlist.has(p.id) ? 'currentColor' : 'none'}" stroke="currentColor" stroke-width="1.8">
          <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l8.72-8.72 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path>
        </svg>
      </button>

      <div class="product-img-container" onclick="openPdpModal('${p.id}')">
        <img src="${p.image}" alt="${p.name} Perfume" loading="lazy" />
        <button class="btn-primary product-quick-add" onclick="quickAddToCart('${p.id}', event)">
          <span>Quick Add — $${p.price}</span>
        </button>
      </div>

      <div class="product-meta">
        <span class="product-category">${p.category} • ${p.family}</span>
        <div class="product-rating"><span>★</span> ${p.rating}</div>
      </div>

      <h4 class="product-title" onclick="openPdpModal('${p.id}')" style="cursor:pointer">${p.name}</h4>
      <p style="font-size:0.78rem; color:var(--text-muted); margin-bottom:0.75rem;">${p.subtitle}</p>

      <div class="product-price-row">
        <span class="product-price">$${p.price}</span>
        <span class="product-size">${p.sizes[1] ? p.sizes[1].size : p.sizes[0].size}</span>
      </div>
    </div>
  `).join('');
}

function filterProducts(category, event) {
  document.querySelectorAll('.filter-chip').forEach(btn => btn.classList.remove('active'));
  if (event && event.target) event.target.classList.add('active');
  renderProductsGrid(category);
}

function initNotesTabs() { switchNoteTab('top'); }

function switchNoteTab(phase) {
  const noteData = FRAGRANCE_NOTES[phase];
  if (!noteData) return;
  document.querySelectorAll('.note-tab-btn').forEach(btn => {
    btn.classList.toggle('active', btn.dataset.phase === phase);
  });
  const card = document.getElementById('notesDisplayCard');
  if (card) {
    card.innerHTML = `
      <span class="tab-phase">${noteData.phase}</span>
      <h3 class="tab-name">${noteData.title}</h3>
      <p class="tab-desc">${noteData.desc}</p>
      
      <div class="note-ingredients-grid">
        ${noteData.ingredients.map(ing => `
          <div class="ingredient-card">
            <div class="ingredient-img-wrapper">
              <img src="${ing.img}" alt="${ing.name}" loading="lazy" />
            </div>
            <h5 class="ingredient-name">${ing.name}</h5>
            <span class="ingredient-origin">${ing.origin}</span>
          </div>
        `).join('')}
      </div>
    `;
  }
}

// Quick view modal functions completely removed for native Shopify navigation.

function selectPdpSize(index) {
  selectedPdpSize = currentActivePdpProduct.sizes[index];
  document.getElementById('pdpPrice').innerText = `$${selectedPdpSize.price}`;
  const buttons = document.querySelectorAll('#pdpSizeContainer .filter-chip');
  buttons.forEach((btn, i) => btn.classList.toggle('active', i === index));
}

function updateEngravingPreview(val) {
  customEngravingText = val.toUpperCase().slice(0, 12);
  const previewLabel = document.getElementById('bottleLabelPreview');
  if (previewLabel) previewLabel.innerText = customEngravingText || currentActivePdpProduct.name.toUpperCase();
}

function addCurrentPdpToCart() {
  addToCart(currentActivePdpProduct, selectedPdpSize.size, selectedPdpSize.price, customEngravingText);
  closePdpModal();
  openCartDrawer();
}

function quickAddToCart(productId, event) {
  if (event) event.stopPropagation();
  const prod = PRODUCTS.find(p => p.id === productId);
  if (!prod) return;
  const sizeObj = prod.sizes[1] || prod.sizes[0];
  addToCart(prod, sizeObj.size, sizeObj.price, '');
  openCartDrawer();
}

function addToCart(product, sizeLabel, price, engraving) {
  const existingIdx = cart.findIndex(item => item.id === product.id && item.size === sizeLabel && item.engraving === engraving);
  if (existingIdx > -1) {
    cart[existingIdx].qty += 1;
  } else {
    cart.push({ id: product.id, name: product.name, image: product.image, size: sizeLabel, price: price, engraving: engraving, qty: 1 });
  }
  updateCartUI();
  showToast(`Added ${product.name} to Cart`);
}

function updateCartUI() {
  const cartBadge = document.getElementById('cartBadgeCount');
  const cartHeading = document.getElementById('cartDrawerHeading');
  const drawerBody = document.getElementById('cartItemsList');
  const subtotalElem = document.getElementById('cartSubtotal');
  const origTotalElem = document.getElementById('cartOriginalTotal');
  const savingsText = document.getElementById('cartSavingsText');
  const drawerFooter = document.getElementById('cartDrawerFooter');

  const totalCount = cart.reduce((sum, item) => sum + item.qty, 0);
  if (cartBadge) cartBadge.innerText = totalCount;
  if (cartHeading) cartHeading.innerText = `Your Cart (${totalCount} item${totalCount === 1 ? '' : 's'})`;

  const subtotal = cart.reduce((sum, item) => sum + (item.price * item.qty), 0);
  const origTotal = Math.round(subtotal * 1.8);
  const savedAmount = Math.max(0, origTotal - subtotal);

  if (subtotalElem) subtotalElem.innerText = `Rs. ${subtotal.toLocaleString()}`;
  if (origTotalElem) origTotalElem.innerText = `Rs. ${origTotal.toLocaleString()}`;
  if (savingsText) savingsText.innerText = `Rs. ${savedAmount.toLocaleString()}`;

  if (drawerBody) {
    if (cart.length === 0) {
      if (drawerFooter) drawerFooter.style.display = 'none';
      drawerBody.innerHTML = `
        <div class="cart-empty-state">
          <div class="empty-cart-icon">
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#777777" stroke-width="1.8">
              <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"></path>
              <line x1="3" y1="6" x2="21" y2="6"></line>
              <path d="M16 10a4 4 0 0 1-8 0"></path>
            </svg>
          </div>
          <h4>Your Cart is Empty</h4>
          <p>Explore our luxury fragrances & niche reserve extraits.</p>
          <button type="button" class="btn-start-shopping" onclick="closeCartDrawer()">START SHOPPING</button>
        </div>`;
    } else {
      if (drawerFooter) drawerFooter.style.display = 'block';
      let itemsHtml = cart.map((item, idx) => {
        const itemLineTotal = item.price * item.qty;
        const itemOrigLineTotal = Math.round(itemLineTotal * 1.8);
        return `
          <div class="cart-item-card">
            <img src="${item.image}" class="cart-item-thumb" alt="${item.name}" />
            <div class="cart-item-details">
              <div class="cart-item-top-row">
                <h5 class="cart-item-name">${item.name}</h5>
                <div class="cart-item-prices">
                  <span class="cart-item-curr-price">Rs. ${itemLineTotal.toLocaleString()}</span>
                  <div class="cart-item-sub-prices">
                    <span class="cart-item-orig-price">Rs. ${itemOrigLineTotal.toLocaleString()}</span>
                    <span class="cart-item-disc-pill">(47% OFF)</span>
                  </div>
                </div>
              </div>

              ${item.size && !item.size.includes('Default Title') ? `<p class="cart-item-meta">${item.size}${item.engraving ? ' • Engraved: "' + item.engraving + '"' : ''}</p>` : ''}


              <div class="cart-item-actions-row">
                <div class="cart-qty-selector">
                  <button type="button" class="cart-qty-btn" onclick="changeCartQty(${idx}, -1)">-</button>
                  <span class="cart-qty-val">${item.qty}</span>
                  <button type="button" class="cart-qty-btn" onclick="changeCartQty(${idx}, 1)">+</button>
                </div>

                <button type="button" class="cart-remove-icon-btn" onclick="removeFromCart(${idx})" title="Remove Item">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#888" stroke-width="1.8">
                    <polyline points="3 6 5 6 21 6"></polyline>
                    <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2 2v2"></path>
                  </svg>
                </button>
              </div>
            </div>
          </div>`;
      }).join('');

      drawerBody.innerHTML = itemsHtml;
    }
  }
}

function changeCartQty(index, delta) {
  cart[index].qty += delta;
  if (cart[index].qty <= 0) cart.splice(index, 1);
  updateCartUI();
}

function removeFromCart(index) {
  cart.splice(index, 1);
  updateCartUI();
}

let isCartDrawerOpen = false;
let lastCartOpenTime = 0;
let lastNotifyCartTime = 0;

window.notifyExternalCartApps = function(cartData) {
  if (!cartData) return;
  try {
    const detail = { cart: cartData, total_price: cartData.total_price, item_count: cartData.item_count };
    
    // Standard Shopify event hooks
    document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail }));
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail }));
    window.dispatchEvent(new CustomEvent('shopify:cart:update', { bubbles: true, detail }));

    // Shiprocket Smart Cart & Fastrr API calls
    if (window.shiprocketSmartCart && typeof window.shiprocketSmartCart.refresh === 'function') {
      try { window.shiprocketSmartCart.refresh(cartData); } catch(e) {}
    }
    if (window.srSmartCart && typeof window.srSmartCart.refresh === 'function') {
      try { window.srSmartCart.refresh(cartData); } catch(e) {}
    }
    if (window.fastrrSmartCart && typeof window.fastrrSmartCart.refresh === 'function') {
      try { window.fastrrSmartCart.refresh(cartData); } catch(e) {}
    }

    // Direct iframe update & refresh so Shiprocket Smart Cart syncs immediately
    const srIframes = document.querySelectorAll('shiprocket-smart-cart iframe, iframe[src*="shiprocket"], iframe[src*="fastrr"], iframe[src*="pickrr"], [id*="shiprocket"] iframe');
    srIframes.forEach(frame => {
      try {
        frame.contentWindow?.postMessage({ type: 'cart_update', cart: cartData }, '*');
        frame.contentWindow?.postMessage({ action: 'cart-updated', data: cartData }, '*');
        frame.contentWindow?.postMessage({ event: 'cart:refresh', cart: cartData }, '*');
        frame.contentWindow?.postMessage(JSON.stringify({ type: 'cart_update', cart: cartData }), '*');
        
        // Reload iframe URL so it pulls latest cart data from Shopify session
        if (frame.src && !frame.src.startsWith('about:')) {
          frame.src = frame.src;
        }
      } catch(e) {}
    });
  } catch(err) {
    console.warn('Error notifying external cart apps:', err);
  }
};

function isShiprocketSmartCartActive() {
  return Boolean(
    window.shiprocketSmartCart ||
    window.srSmartCart ||
    window.fastrrSmartCart ||
    document.querySelector('shiprocket-smart-cart, #shiprocket-smart-cart, #sr-smart-cart, .sr-smart-cart-container, [id*="shiprocket-smart-cart"]')
  );
}

function openCartDrawer(e) { 
  if (e && e.preventDefault) e.preventDefault();
  
  // Prevent duplicate trigger within 350ms
  const now = Date.now();
  if (now - lastCartOpenTime < 350) return;
  lastCartOpenTime = now;

  // Always open Theme's native luxury cart drawer (instant 0ms update, no reload required)
  const el = document.getElementById('cartBackdrop');
  if (el) el.classList.add('open'); 
  document.body.classList.add('cart-drawer-open', 'drawer-open');
  if (typeof window.handleStickyBarVisibility === 'function') window.handleStickyBarVisibility();

  if (!isCartDrawerOpen) {
    isCartDrawerOpen = true;
    try {
      history.pushState({ modal: 'cart-drawer' }, '', window.location.href);
    } catch(e) {}
  }
}
window.openCartDrawer = openCartDrawer;


function closeCartDrawer(fromPopState) { 
  const el = document.getElementById('cartBackdrop');
  if (el) el.classList.remove('open'); 
  document.body.classList.remove('cart-drawer-open', 'drawer-open');
  if (typeof window.handleStickyBarVisibility === 'function') window.handleStickyBarVisibility();

  if (isCartDrawerOpen) {
    isCartDrawerOpen = false;
    if (fromPopState !== true) {
      if (window.history.state && window.history.state.modal === 'cart-drawer') {
        window.history.back();
      }
    }
  }
}
window.closeCartDrawer = closeCartDrawer;

// Intercept phone Android back button / swipe back gesture so website does NOT exit
window.addEventListener('popstate', function(e) {
  if (isCartDrawerOpen) {
    closeCartDrawer(true);
  }
});

function initCartEvents() {
  const backdrop = document.getElementById('cartBackdrop');
  if (backdrop) {
    backdrop.addEventListener('click', (e) => {
      if (e.target === backdrop) closeCartDrawer();
    });
  }
}

function openQuizModal() {
  quizStep = 1; quizAnswers = {};
  renderQuizStep();
  document.getElementById('quizModal').classList.add('open');
}

function closeQuizModal() { document.getElementById('quizModal').classList.remove('open'); }

function toggleWishlist(id, e) {
  if (e) e.stopPropagation();
  if (wishlist.has(id)) {
    wishlist.delete(id);
    showToast('Removed from Wishlist');
  } else {
    wishlist.add(id);
    showToast('✨ Added to Wishlist');
  }
  const badge = document.getElementById('wishlistCount');
  if (badge) badge.innerText = wishlist.size;
  renderProductsGrid('all');
}

function showToast(msg) {
  const container = document.getElementById('toastContainer') || createToastContainer();
  const toast = document.createElement('div');
  toast.className = 'toast-msg';
  toast.innerHTML = `<span>${msg}</span>`;
  container.appendChild(toast);
  setTimeout(() => {
    toast.style.opacity = '0';
    setTimeout(() => toast.remove(), 300);
  }, 3000);
}

function createToastContainer() {
  const el = document.createElement('div');
  el.id = 'toastContainer';
  el.className = 'toast-container';
  document.body.appendChild(el);
  return el;
}

function triggerBadgePop() {
  const badge = document.getElementById('cartBadgeCount');
  if (badge) {
    badge.classList.remove('pop-anim');
    void badge.offsetWidth;
    badge.classList.add('pop-anim');
  }
}

function initScrollAnimations() {
  const elementsToAnimate = document.querySelectorAll(
    '.section-header, .reels-section-header, .testimonial-main-title, .perfume-card, .collection-card, .benefit-card, .pillar-item, .avatar-item, .reel-card-item, .newsletter-card, .essence-card-dark, .essence-card-light'
  );

  elementsToAnimate.forEach((el) => {
    el.classList.add('reveal-on-scroll');
    
    // Add staggered wave delays for grid elements
    const parentGrid = el.closest('.perfume-range-grid, .reels-track-flex, .benefits-grid, .pillars-grid, .avatar-list-flex');
    if (parentGrid) {
      const children = Array.from(parentGrid.children);
      const childIndex = children.indexOf(el);
      if (childIndex >= 0) {
        el.style.transitionDelay = `${(childIndex % 6) * 0.08}s`;
      }
    }
  });

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
      }
    });
  }, { threshold: 0.1 });

  elementsToAnimate.forEach(el => observer.observe(el));

  document.querySelectorAll('.perfume-statement-section, .editorial-statement-section').forEach(sec => {
    observer.observe(sec);
  });
}

function showCartNotification(title, itemCount) {
  const container = document.getElementById('toastContainer') || createToastContainer();
  const toast = document.createElement('div');
  toast.className = 'toast-msg aeris-cart-toast';
  toast.innerHTML = `
    <div style="display:flex; align-items:center; justify-content:space-between; gap:12px; width:100%;">
      <div style="display:flex; align-items:center; gap:8px;">
        <span style="display:inline-flex; align-items:center; justify-content:center; width:22px; height:22px; border-radius:50%; background:#25D366; color:#FFF; font-size:12px; font-weight:800; flex-shrink:0;">✓</span>
        <span style="font-size:0.82rem; color:#FFFFFF; font-weight:600; line-height:1.2;"><strong>${title}</strong> added to cart</span>
      </div>
      <button type="button" onclick="openCartDrawer()" style="background:linear-gradient(135deg, #ECC860, #D4AF37); color:#120D0E; border:none; padding:5px 12px; border-radius:999px; font-size:0.72rem; font-weight:800; letter-spacing:0.04em; text-transform:uppercase; cursor:pointer; box-shadow:0 2px 8px rgba(212,175,55,0.4); white-space:nowrap; flex-shrink:0;">
        VIEW CART (${itemCount})
      </button>
    </div>
  `;
  container.appendChild(toast);
  setTimeout(() => {
    toast.style.opacity = '0';
    toast.style.transform = 'translateY(10px)';
    setTimeout(() => toast.remove(), 350);
  }, 3500);
}

window.quickAddShopifyItem = function(variantId, title, image, price, event) {
  let targetBtn = null;
  if (event) {
    if (event.preventDefault) event.preventDefault();
    if (event.stopPropagation) event.stopPropagation();
    const rawEl = event.currentTarget || event.target;
    targetBtn = (rawEl && typeof rawEl.closest === 'function') 
      ? (rawEl.closest('.mobile-card-quick-add, .hover-addtocart-gold-bar, .reel-quick-add-btn, button') || rawEl) 
      : rawEl;
  }

  let origHtml = '';
  if (targetBtn) {
    origHtml = targetBtn.innerHTML;
    targetBtn.style.pointerEvents = 'none';
    targetBtn.classList.add('btn-loading');
    targetBtn.innerHTML = `
      <span class="aeris-btn-spinner"></span>
      <span>ADDING...</span>
    `;
  }

  const vId = parseInt(variantId);
  const cleanPrice = price > 1000 ? price / 100 : (price || 1199);

  const applySuccessUI = (cartData) => {
    if (cartData && typeof updateShopifyCartDrawerUI === 'function') {
      updateShopifyCartDrawerUI(cartData);
    }
    if (typeof triggerBadgePop === 'function') {
      triggerBadgePop();
    }

    if (targetBtn) {
      targetBtn.classList.remove('btn-loading');
      targetBtn.classList.add('is-added');
      targetBtn.style.pointerEvents = 'auto';
      targetBtn.innerHTML = `
        <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#25D366" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" style="display:inline-block; vertical-align:middle; margin-right:4px;">
          <polyline points="20 6 9 17 4 12"></polyline>
        </svg>
        <span>ADDED ✓</span>
      `;

      setTimeout(() => {
        if (targetBtn) {
          targetBtn.classList.remove('is-added');
          targetBtn.innerHTML = origHtml;
        }
      }, 2500);
    }

    const currentTotalItems = (cartData && cartData.item_count) || (window.cart && window.cart.length) || 1;
    showCartNotification(title, currentTotalItems);

    // On Desktop (>768px): open cart drawer.
    // On Mobile (<=768px): DO NOT force-open drawer, allowing smooth uninterrupted shopping!
    const isMobile = window.innerWidth <= 768;
    if (!isMobile) {
      openCartDrawer();
    }
  };

  const handleFallback = () => {
    fetch('/cart.js')
      .then(res => res.json())
      .then(cartData => {
        applySuccessUI(cartData);
      })
      .catch(() => {
        if (targetBtn) {
          targetBtn.classList.remove('btn-loading');
          targetBtn.style.pointerEvents = 'auto';
          targetBtn.innerHTML = origHtml;
        }
      });
  };

  if (vId && vId > 0) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ id: vId, quantity: 1 })
    })
    .then(res => {
      if (!res.ok) {
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: vId, quantity: 1 }] })
        }).then(r => r.json());
      }
      return res.json();
    })
    .then(data => {
      fetch('/cart.js')
        .then(res => res.json())
        .then(cartData => {
          if (cartData && cartData.item_count > 0) {
            applySuccessUI(cartData);
          } else {
            handleFallback();
          }
        })
        .catch(() => handleFallback());
    })
    .catch(err => {
      console.log('Shopify Cart Add fallback:', err);
      handleFallback();
    });
  } else {
    setTimeout(() => {
      handleFallback();
    }, 250);
  }
};

window.refreshShopifyCartDrawer = function() {
  fetch('/cart.js')
    .then(res => res.json())
    .then(cartData => {
      updateShopifyCartDrawerUI(cartData);
      openCartDrawer();
    })
    .catch(() => {
      openCartDrawer();
    });
};

window.updateShopifyCartDrawerUI = function(cartData) {
  if (!cartData) return;
  if (typeof window.notifyExternalCartApps === 'function') {
    window.notifyExternalCartApps(cartData);
  }
  const cartBadge = document.getElementById('cartBadgeCount');
  const cartHeading = document.getElementById('cartDrawerHeading');
  const drawerBody = document.getElementById('cartItemsList');
  const subtotalElem = document.getElementById('cartSubtotal');
  const origTotalElem = document.getElementById('cartOriginalTotal');
  const savingsText = document.getElementById('cartSavingsText');
  const drawerFooter = document.getElementById('cartDrawerFooter');

  const totalCount = cartData.item_count || 0;
  if (cartBadge) cartBadge.innerText = totalCount;
  if (cartHeading) cartHeading.innerText = `Your Cart (${totalCount} item${totalCount === 1 ? '' : 's'})`;

  const subtotalVal = (cartData.total_price || 0) / 100;
  const subtotalFormatted = subtotalVal > 0 ? `Rs. ${subtotalVal.toLocaleString('en-IN')}` : 'Rs. 0.00';
  const origTotalVal = Math.round(subtotalVal * 1.8);
  const origTotalFormatted = origTotalVal > 0 ? `Rs. ${origTotalVal.toLocaleString('en-IN')}` : 'Rs. 0.00';
  const savedVal = Math.max(0, origTotalVal - subtotalVal);
  const savedFormatted = savedVal > 0 ? `Rs. ${savedVal.toLocaleString('en-IN')}` : 'Rs. 0.00';

  if (subtotalElem) subtotalElem.innerText = subtotalFormatted;
  if (origTotalElem) origTotalElem.innerText = origTotalFormatted;
  if (savingsText) savingsText.innerText = savedFormatted;

  if (drawerBody) {
    if (totalCount === 0) {
      if (drawerFooter) drawerFooter.style.display = 'none';
      drawerBody.innerHTML = `
        <div class="cart-empty-state">
          <div class="empty-cart-icon">
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#777777" stroke-width="1.8">
              <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"></path>
              <line x1="3" y1="6" x2="21" y2="6"></line>
              <path d="M16 10a4 4 0 0 1-8 0"></path>
            </svg>
          </div>
          <h4>Your Cart is Empty</h4>
          <p>Explore our luxury fragrances & niche reserve extraits.</p>
          <button type="button" class="btn-start-shopping" onclick="closeCartDrawer()">START SHOPPING</button>
        </div>`;
    } else {
      if (drawerFooter) drawerFooter.style.display = 'block';
      let itemsHtml = cartData.items.map((item) => {
        const itemLineTotal = (item.final_line_price || 0) / 100;
        const itemPriceFormatted = `Rs. ${itemLineTotal.toLocaleString('en-IN')}`;
        const itemOrigLineTotal = Math.round(itemLineTotal * 1.8);
        const itemOrigPriceFormatted = `Rs. ${itemOrigLineTotal.toLocaleString('en-IN')}`;
        return `
          <div class="cart-item-card" data-key="${item.key}">
            <img src="${item.image}" class="cart-item-thumb" alt="${item.product_title}" />
            <div class="cart-item-details">
              <div class="cart-item-top-row">
                <h5 class="cart-item-name">${item.product_title}</h5>
                <div class="cart-item-prices">
                  <span class="cart-item-curr-price">${itemPriceFormatted}</span>
                  <div class="cart-item-sub-prices">
                    <span class="cart-item-orig-price">${itemOrigPriceFormatted}</span>
                    <span class="cart-item-disc-pill">(47% OFF)</span>
                  </div>
                </div>
              </div>

              ${item.variant_title && !item.variant_title.includes('Default Title') ? `<p class="cart-item-meta">${item.variant_title}</p>` : ''}
              ${item.properties && Object.keys(item.properties).length > 0 ? `
                <div class="cart-item-bundle-props" style="margin: 4px 0 6px 0; font-size: 0.72rem; color: #7A5C1F; background: #FFFDF9; border: 1px dashed #E8DEC8; padding: 4px 8px; border-radius: 6px;">
                  ${Object.entries(item.properties).filter(([k, v]) => !k.startsWith('_') && Boolean(v)).map(([k, v]) => `
                    <div style="line-height: 1.35;"><span style="font-weight: 600; color: #4A121A;">${k}:</span> ${v}</div>
                  `).join('')}
                </div>
              ` : ''}
              <div class="cart-item-actions-row">
                <div class="cart-qty-selector">
                  <button type="button" class="cart-qty-btn" onclick="changeShopifyCartQty('${item.key}', ${item.quantity - 1})">-</button>
                  <span class="cart-qty-val">${item.quantity}</span>
                  <button type="button" class="cart-qty-btn" onclick="changeShopifyCartQty('${item.key}', ${item.quantity + 1})">+</button>
                </div>

                <button type="button" class="cart-remove-icon-btn" onclick="changeShopifyCartQty('${item.key}', 0)" title="Remove Item">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#888" stroke-width="1.8">
                    <polyline points="3 6 5 6 21 6"></polyline>
                    <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2 2v2"></path>
                  </svg>
                </button>
              </div>
            </div>
          </div>`;
      }).join('');

      drawerBody.innerHTML = itemsHtml;
    }
  }
};

window.changeShopifyCartQty = function(lineKey, newQty) {
  const qty = Math.max(0, parseInt(newQty, 10) || 0);
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({ id: String(lineKey), quantity: qty })
  })
  .then(res => {
    if (!res.ok) throw new Error('Cart change failed');
    return res.json();
  })
  .then(cartData => {
    updateShopifyCartDrawerUI(cartData);
  })
  .catch((err) => {
    console.warn('Cart change error, refreshing:', err);
    refreshShopifyCartDrawer();
  });
};

window.changeCartQty = function(lineKey, newQty) {
  window.changeShopifyCartQty(lineKey, newQty);
};

window.removeFromCart = function(lineKey) {
  window.changeShopifyCartQty(lineKey, 0);
};

document.addEventListener('submit', function(e) {
  const form = e.target;
  if (form && form.action && (form.action.includes('/cart/add') || form.getAttribute('action') === '/cart/add')) {
    e.preventDefault();
    const formData = new FormData(form);
    fetch('/cart/add.js', {
      method: 'POST',
      body: formData,
      headers: { 'Accept': 'application/json' }
    })
    .then(res => res.json())
    .then(data => {
      showToast('Added to Cart!');
      refreshShopifyCartDrawer();
    })
    .catch(err => {
      form.submit();
    });
  }
});

/* Mobile Side Navigation Drawer Functions */
window.openMobileNav = function() {
  const backdrop = document.getElementById('mobileNavBackdrop');
  const drawer = document.getElementById('mobileNavDrawer');
  if (backdrop && drawer) {
    backdrop.classList.add('open');
    drawer.classList.add('open');
    document.body.classList.add('mobile-nav-open', 'drawer-open');
    document.body.style.overflow = 'hidden';
    if (typeof window.handleStickyBarVisibility === 'function') window.handleStickyBarVisibility();
  }
};

window.closeMobileNav = function() {
  const backdrop = document.getElementById('mobileNavBackdrop');
  const drawer = document.getElementById('mobileNavDrawer');
  if (backdrop && drawer) {
    backdrop.classList.remove('open');
    drawer.classList.remove('open');
    document.body.classList.remove('mobile-nav-open', 'drawer-open');
    document.body.style.overflow = '';
    if (typeof window.handleStickyBarVisibility === 'function') window.handleStickyBarVisibility();
  }
};
